const VISITOR_STORAGE_KEY = 'nettgrav:first-party-visitor:v1';
const SESSION_STORAGE_KEY = 'nettgrav:first-party-session:v1';
const CLIENT_ID_PATTERN = /^(?:[a-f0-9]{32}|[a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12})$/i;

export const FIRST_PARTY_SESSION_TIMEOUT_MS = 30 * 60 * 1000;

let memoryVisitorId;
let memorySession;

const browserStorage = () => {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    return null;
  }
};

const browserCrypto = () => (typeof window !== 'undefined' ? window.crypto : null);

const generateId = (cryptoImpl) => {
  if (typeof cryptoImpl?.randomUUID === 'function') return cryptoImpl.randomUUID();

  if (typeof cryptoImpl?.getRandomValues === 'function') {
    const bytes = new Uint8Array(16);
    cryptoImpl.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  }

  return null;
};

const readSession = (storage) => {
  try {
    const value = JSON.parse(storage?.getItem(SESSION_STORAGE_KEY) || 'null');
    if (!CLIENT_ID_PATTERN.test(value?.id || '') || !Number.isFinite(value?.lastSeenAt)) return null;
    return value;
  } catch {
    return null;
  }
};

export const getFirstPartyTrafficIdentity = ({
  now = Date.now(),
  storage,
  cryptoImpl,
} = {}) => {
  const activeStorage = storage === undefined ? browserStorage() : storage;
  const activeCrypto = cryptoImpl === undefined ? browserCrypto() : cryptoImpl;
  let visitorId;
  try {
    visitorId = activeStorage?.getItem(VISITOR_STORAGE_KEY) || null;
  } catch {}

  if (!CLIENT_ID_PATTERN.test(visitorId || '')) visitorId = null;
  visitorId ||= memoryVisitorId || generateId(activeCrypto);
  if (!visitorId) return null;
  memoryVisitorId = visitorId;

  try {
    activeStorage?.setItem(VISITOR_STORAGE_KEY, visitorId);
  } catch {}

  const storedSession = readSession(activeStorage) || memorySession;
  const sessionExpired =
    !storedSession || now - storedSession.lastSeenAt >= FIRST_PARTY_SESSION_TIMEOUT_MS;
  const sessionId = sessionExpired ? generateId(activeCrypto) : storedSession.id;
  if (!sessionId) return null;

  const session = { id: sessionId, lastSeenAt: now };
  memorySession = session;
  try {
    activeStorage?.setItem(SESSION_STORAGE_KEY, JSON.stringify(session));
  } catch {}

  return { visitorId, sessionId };
};

export const resetFirstPartyTrafficIdentityForTests = () => {
  memoryVisitorId = undefined;
  memorySession = undefined;
};
